import { NewDestination } from 'types/stream';

const getDestinationTitle = (destination?: NewDestination) => {
  const isTwitch = destination?.network === 'TWITCH';

  return isTwitch ? 'Twitch account' : destination?.title;
};

export default getDestinationTitle;
